module.exports = __webpack_public_path__ + "static/img/bg7.43d9d0e3.png";